/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div.image-container[_ngcontent-%COMP%], div.image-placeholder[_ngcontent-%COMP%]{cursor:pointer;width:110px;height:110px;border:1px solid #cfd0dd;font-size:14px;color:#cfd0dd;display:flex;justify-content:center;align-items:center;text-align:center;margin:0 auto}img.product-image[_ngcontent-%COMP%]{width:110px;height:110px}.small[_ngcontent-%COMP%]{width:70px!important;height:70px!important;font-size:10px!important}.extra-small[_ngcontent-%COMP%]{width:60px!important;height:60px!important;font-size:10px!important}"];
export { styles as styles };
